import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './BalanceSheet.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClients } from '../store/clientsSlice';
import { buildAuthHeaders, getAccessToken } from '../utils/authHeaders';
const apiUrl = process.env.REACT_APP_API_URL;
const BalanceSheet = () => {
  const dispatch = useDispatch();
  const { clientId, financialYear } = useSelector((state) => state.app);
  const accessToken = useSelector((state) => state.auth.access_token);
  const [error, setError] = useState('');

  const [data, setData] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // Track whether we're in edit mode
const[balanceSheet,setBalanceSheet]=useState({});

  useEffect(() => {
    dispatch(fetchClients());
    generateBalanceSheet(clientId, financialYear, accessToken, setData, setBalanceSheet, setError);
  }, [accessToken, dispatch, clientId, financialYear]);
  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };
  const handleSaveAll = () => {
    axios.put(`${apiUrl}/api/balancesheet/update`,{
      
      clientId,
      financialYear,
      ...balanceSheet
    },{
      params: {
        clientId,
        financialYear
      },
      headers: buildAuthHeaders(getAccessToken(accessToken))

    }).then(()=>{
      generateBalanceSheet(clientId, financialYear, accessToken, setData, setBalanceSheet, setError);
      setIsEditing(false); // Disable editing after saving})
    }).catch(err => {
         console.error('Error saving balance sheet', err);
         alert('Error saving  balance sheet.');
       });
    
  }

  const handleBalanceSheetChange = (key, value) => {
    
    setBalanceSheet(prevState => ({
      ...prevState,
      [key]: value, // Update the specific key with the new value
    }));
    
  };

  return (
    <div className="balance-sheet-page">
      <h2>Balance Sheet</h2>
      <p className="financial-page-subtitle">Review assets and liabilities on the same full-width report shell used by the other finance statements.</p>
      <div className="filters">
      </div>
      {error && <p className="financial-message financial-message--error">{error}</p>}
      {data && (
        <div className="table-container">
          <div className="financial-toolbar">
            <button className="financial-button" onClick={isEditing ? handleSaveAll : handleEditToggle}>
              {isEditing ? 'Save All' : 'Edit'}
            </button>
          </div>
          <table className="balance-sheet-table">
            <thead>
              <tr>
                <th>Liabalities</th>
                <th>Amount</th>
                <th>Assets</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.Liabilities && data.Assets && (() => {
                const liabilitiesKeys = Object.keys(data.Liabilities);
                const assetsKeys = Object.keys(data.Assets);
                const maxLength = Math.max(liabilitiesKeys.length, assetsKeys.length);

                return Array.from({ length: maxLength }).map((_, index) => {
                  const liabilityKey = liabilitiesKeys[index] || null;
                  const assetKey = assetsKeys[index] || null;
                  const liabilityItems = liabilityKey ? Object.entries(data.Liabilities[liabilityKey]) : [];
                  const assetItems = assetKey ? Object.entries(data.Assets[assetKey]) : [];
                  const maxItemsLength = Math.max(liabilityItems.length, assetItems.length);

                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td colSpan="2"><strong>{liabilityKey || ''}</strong></td>
                        <td colSpan="2"><strong>{assetKey || ''}</strong></td>
                      </tr>
                      {Array.from({ length: maxItemsLength }).map((_, subIndex) => {
                        const [liabilitySubKey, liabilityValue] = liabilityItems[subIndex] || [];
                        const [assetSubKey, assetValue] = assetItems[subIndex] || [];

                        return (
                          <tr key={subIndex}>
                            <td style={{ paddingLeft: '20px' }}>{liabilitySubKey || ''}</td>
                            <td style={{ paddingLeft: '20px' }}>
                              {isEditing ? (
                                <input
                                  type="number"
                                  value={
                                    balanceSheet[`liability_${liabilityKey}_${liabilitySubKey}`] !== undefined
                                      ? balanceSheet[`liability_${liabilityKey}_${liabilitySubKey}`]
                                      : (liabilityValue || '')
                                  }
                                  onChange={e => handleBalanceSheetChange(`liability_${liabilityKey}_${liabilitySubKey}`, e.target.value)}
                                />
                              ) : (
                                liabilityValue || ''
                              )}
                            </td>
                            <td style={{ paddingLeft: '20px' }}>{assetSubKey || ''}</td>
                            <td style={{ paddingLeft: '20px' }}>
                              {isEditing ? (
                                <input
                                  type="number"
                                  value={
                                    balanceSheet[`asset_${assetKey}_${assetSubKey}`] !== undefined
                                      ? balanceSheet[`asset_${assetKey}_${assetSubKey}`]
                                      : (assetValue || '')
                                  }
                                  onChange={e => handleBalanceSheetChange(`asset_${assetKey}_${assetSubKey}`, e.target.value)}
                                />
                              ) : (
                                assetValue || ''
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                });
              })()}
              <tr>
                <td colSpan="1">Total : </td><td>{data.totalLiabilities}</td>
                <td colSpan="1">Total : </td><td>{data.totalAssets}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BalanceSheet;

function generateBalanceSheet(clientId, financialYear, accessToken, setData, setBalanceSheet, setError) {
  axios.get(`${apiUrl}/api/balancesheet/generate`, {
    params: {
      clientId,
      financialYear
    },
    headers: buildAuthHeaders(getAccessToken(accessToken))
  })
    .then(res => {
      setData(res.data);
      // Flatten all editable fields for easier editing
      const newSheet = {};
      if (res.data && res.data.Liabilities) {
        Object.entries(res.data.Liabilities).forEach(([liabKey, liabObj]) => {
          Object.entries(liabObj).forEach(([subKey, value]) => {
            newSheet[`liability_${liabKey}_${subKey}`] = value;
          });
        });
      }
      if (res.data && res.data.Assets) {
        Object.entries(res.data.Assets).forEach(([assetKey, assetObj]) => {
          Object.entries(assetObj).forEach(([subKey, value]) => {
            newSheet[`asset_${assetKey}_${subKey}`] = value;
          });
        });
      }
      setBalanceSheet(newSheet);
      setError('');
    })
    .catch(err => {
      console.error('Error fetching profit and loss account', err);
      setError('Error fetching data from API.');
    });
}
